<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="grid grid-cols-12">
                <div class="col-span-12 mb-4 lg:col-span-6 lg:pr-4 lg:mb-0">
                    <vx-badge color="violet" size="sm" class="px-2!">
                        Optional
                        <font-awesome-icon widthAuto :icon="faPencilSlash"></font-awesome-icon>
                    </vx-badge>
                    <h3 class="mt-2 text-xl text-slate-700 font-extrabold">Starter Template</h3>
                    <p class="text-sm">Download a template to get going.</p>
                </div>
                <div class="col-span-12 lg:col-span-6">
                    <csv-template :downloadHref="csvUrl">
                        <template v-slot:head>
                            <tr>
                                <th>name</th>
                                <th>email</th>
                            </tr>
                        </template>

                        <tr>
                            <td>Jane Smith</td>
                            <td>jane.smith@example.com</td>
                        </tr>
                    </csv-template>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faPencilSlash } from '@fortawesome/pro-solid-svg-icons';
import { VxExpandableCard, VxBadge } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import csvUrl from '@csv/users_csv_upload_template.csv';
import CsvTemplate from '~/components/general/CsvTemplate.vue';
</script>
